import PropTypes from 'prop-types';

import MyProfileSideBarItem from '../MyProfileSideBarItem/MyProfileSideBarItem';
import Workspace from '../../entities/workspace';
import workspaceIcon from '../../assets/img/workspace_icon.png';

const workspacePlanName = ( workspace ) => {
	if ( !workspace.subscriptionPlanName ) return '';

	return workspace.subscriptionPlanName.replace( ' Plan', '' ) + ( workspace.isOnFreeTrial ? ' Trial' : '' );
};

const workspacePlanTagColor = () => 'var(--color-feedback-on-success)';

const WorkspaceSideBarItem = ( {
	workspace, selected, onClick, currentUserID
} ) => {
	const planToDisplay = {
		name: workspacePlanName( workspace ),
		tagColor: workspacePlanTagColor()
	};

	return (
		<MyProfileSideBarItem
			title={workspace.name}
			subtitle={workspace.currentRoleIdToDisplay}
			image={workspaceIcon}
			selected={selected}
			onClick={onClick}
			workspace={workspace}
			currentUserID={currentUserID}
			planToDisplay={planToDisplay}
		/>
	);
};

WorkspaceSideBarItem.propTypes = {
	workspace: PropTypes.instanceOf( Workspace ).isRequired,
	selected: PropTypes.bool,
	onClick: PropTypes.func,
	currentUserID: PropTypes.number.isRequired
};

WorkspaceSideBarItem.defaultProps = {
	selected: false,
	onClick: () => {}
};

export default WorkspaceSideBarItem;
